export const getters = {
  account: state => state.account,
  accounts: state => state.accounts,
};

export default getters;
